import React from 'react';
import background from '../../assets/nasa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoSpaceagencies extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        description="Space Agencies"
        paragraph="As of 2018, 72 different government space agencies are in existence. Six government space agencies have full launch capabilities."
        background={background}
     />
  
  );
 }
}   

export default InfoSpaceagencies;